import { initializeApp } from "firebase/app";
// import { getAuth, onAuthStateChanged,signInWithEmailAndPassword, signOut } from "firebase/auth";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { ref } from 'vue';
// import { doc, getDoc, getFirestore } from "firebase/firestore";
import { doc, getDoc, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { caricaImpostazioniDaFirestore, caricaVersioneDaFirestore, caricaDbClientiDaFirestore, caricaDbContattiDaFirestore, caricaDbListiniDaFirestore, caricaDatiFreddiDaStorage, popolaInfoContattiDaClienti } from './gestioneDB';
import { mostraInfoSviluppo } from "./utilita";
export const credenzialiUtente = ref(null);
export const idUtenteGoogle = ref(null);

// Configurazione Firebase web app
const firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID
};

// Initializza Firebase
const app = initializeApp(firebaseConfig);
// Inizializza  Google Auth
const provider = new GoogleAuthProvider();
// Initializza Firebase Authentication
export const auth = getAuth(app);
// Inizializza Firestore
// export const db = getFirestore(app); // -> Sostituito da initializeFirestore
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager({ forceOwnership: true })
  })
});

auth.onAuthStateChanged(async function(user) {
    idUtenteGoogle.value = null;
    credenzialiUtente.value = null;

    if (user) {
        console.log('Utente connesso');
        idUtenteGoogle.value = user.uid;
        const docRef = doc(db, "utenti", user.uid);
        const docSnap = await getDoc(docRef);
        credenzialiUtente.value = docSnap.data();
        // console.log('CREDENZIALI UTENTE');
        // console.log(JSON.stringify(credenzialiUtente.value));
        // console.log('UTENTE');
        // console.log(JSON.stringify(user.uid));
        if (!credenzialiUtente.value) {
            logoutUtente();
        }
        mostraInfoSviluppo.value = false;
        // console.log('Utente:' + user.uid);
        // console.log(JSON.stringify(credenzialiUtente.value));

        // // Carica la versione
        await caricaVersioneDaFirestore();
        // Carica i database
        await caricaImpostazioniDaFirestore();
        await caricaDbListiniDaFirestore();
        await Promise.all([
            caricaDbContattiDaFirestore(), // Modificata a 5 giorni
            caricaDbClientiDaFirestore(),  // Modificata a 5 giorni
            caricaDatiFreddiDaStorage()    // Download JSON da Storage
        ]);
        popolaInfoContattiDaClienti();
        // await caricaDbContattiDaFirestore();
        // await caricaDbClientiDaFirestore();
    }
});

// export function loginUtente(nomeutente, pwutente){
export async function loginUtente(){
    console.log('Tento di registrarmi');
    // Autenticazione con nome utente e password
    // signInWithEmailAndPassword(auth, nomeutente, pwutente)
    //     .catch((error) => {
    //     const errorCode = error.code;
    //     const errorMessage = error.message;
    //     console.log(errorCode);
    //     console.log(errorMessage);
    //     });
    // Autenticazione Google
    signOut(auth).then(() => {
        signInWithPopup(auth, provider)
            .then((result) => {
                // user.value = result.user;
                console.log(result.user.displayName);
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.log(errorCode);
                console.log(errorMessage);
            });    
    });
}

export function logoutUtente() {
    signOut(auth);
    console.log('Disconnesso');
}